module.exports = __webpack_public_path__ + "static/story-e07d7bcb6922b0755367712dd687b78d.jpg";